
<div *ngIf="notifOpened"  [ngClass]="{'side-panel': notifOpened, 'notif-close': !notifOpened}" tabindex="9999" (focusout)="showNotiDetail = false" >

    <div  *ngFor="let button of buttons">
      <div [title]="button?.aciklama"
      [ngClass]="{'circle-button-has-notif':button?.adet > 0,'circle-button':button?.adet == 0,
        'expanded': showNotiDetail
      }"
      (mouseenter)="hoveredButton = button"
      (mouseleave)="hoveredButton = null"
      (click)="buttonClick(button)"
      >
      <div class="icon">
        <i class="dx-icon-{{ button?.icon }}"></i>
        <div class="badge" *ngIf="button?.adet > 0">{{ button.adet }}</div>
      </div>
      <div class="button-text">
        {{ button.aciklama }}
      </div>
    </div>
  </div>
  <div style="height: 100%;width:100%;display:flex" (click)="showNotiDetail = !showNotiDetail"
  (blur)="showNotiDetail = false">
  </div>
</div>